export const getClientType = () => {
    // Intentionally read the raw return parameter here because we only inspect the
    // nested client_type value for native callback URLs (for example,
    // vendregister://callback?...). The full return value is never used as a
    // navigation target.
    // eslint-disable-next-line no-restricted-syntax
    const returnURL = new URLSearchParams(window.location.search).get('return');
    if (!returnURL) {
        return '';
    }
    try {
        const [_, paramString] = returnURL.split('?');
        const params = new URLSearchParams(paramString);
        return params.get('client_type') || '';
    }
    catch (_a) {
        return '';
    }
};
